module.exports = __webpack_public_path__ + "img/coinbankC33.cf414b22.jpg";